module.exports = __webpack_public_path__ + "static/media/dice-d8.b1c0d3c4.svg";